<template>
  <div class="holder">
    <slot></slot>
  </div>
</template>

<script>
import { getOrientation, getRotationAngle } from './util';
import { getMobileOS } from '@/helpers';

export default {
  mounted() {
    const slot = this.$slots.default[0];

    if (slot.tag !== 'img') {
      console.error('Warning: slot should be an img tag.');
      return;
    }

    const holder = this.$el;
    const img = holder.childNodes[0];
    /*img.style['opacity'] = 0; //TODO - Fix this (GetOrientation. Blob can't read meta data?)
    getOrientation(img)
      .then(function(currentOrientation) {
        if (getMobileOS() === 'iOS') return;
        if (!currentOrientation) {
          return; // Not jpeg
        }

        const angle = getRotationAngle(1, currentOrientation);
        const transform = `rotateY(${angle.y}deg) rotateZ(${angle.z}deg)`;

        let translate = '';
        if (angle.z % 180 !== 0) {
          const height = img.clientHeight;
          const width = img.clientWidth;

          translate = `translate(${(height - width) / 2}px, ${(width - height) / 2}px)`;
          holder.style['width'] = `${height}px`;
          holder.style['height'] = `${width}px`;
          img.style['width'] = `${width}px`;
          img.style['height'] = `${height}px`;
        }
        img.style['vertical-align'] = 'bottom';
        img.style['transform'] = translate + ' ' + transform;
      })
      .finally(() => (img.style['opacity'] = 1));*/
  }
};
</script>

<style scoped>
.holder {
  display: inline-block;
  width: auto;
  height: 100%;
  background-color: white;
}
</style>
